/*
 * @Author: yeyimei
 * @Date: 2022-09-22 17:09:10
 * @LastEditTime: 2024-03-22 15:47:03
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\store\index.js
 */

import { createStore } from 'vuex'
import Kfc from './modules/kfc'
import mc from './modules/mc'
import mall from './modules/mall'
import movice from './modules/movice'
import { isNotEmpty } from '@/libs/tools.js'
import { isIos } from '@/libs/gcontrol'
import {
  getAppIdStorage,
  getStorage,
  setStorage,
  setAppIdStorage,
} from '@/libs/storage'
import { openStatus } from '@/utils/api'

let appId = getStorage('appId')
let INFOS_STORAGE = getAppIdStorage(appId) || {}
export default createStore({
  state: {
    isWeixin: false,
    isPath: true, //H5返回小程序判断
    fromPath: '',
    userInfo: INFOS_STORAGE.userInfo,
    hasMobile: isNotEmpty(INFOS_STORAGE.userInfo?.mobile),
    city: '',
    environment: localStorage.getItem('environment') || '',
    cachedViews: ['search', 'dine-libertinismtwo', 'parentCpn', 'mall'], //路由缓存
    showBack: getAppIdStorage(appId)?.showBack || 'true',
    iosPath: '',
    mercode: localStorage.getItem('mercode') || '10',
    newDot: INFOS_STORAGE.newDot == undefined ? true : INFOS_STORAGE.newDot,
    wechatSignUrl: '', //缓存ios第一次进入应用的url
    pointsValue: 0, //积分
    distUserInfo: getAppIdStorage(appId)?.distUserInfo || null,
    userConfigInfo: INFOS_STORAGE.userConfigInfo,
    bottomNavList: INFOS_STORAGE.bottomNavList,
    appId: getStorage('appId'),
    infos_storage: getAppIdStorage(appId) || {},

    hexiaoInfo: getStorage('hexiaoUserInfo') || {} // 核销用户信息
  },
  getters: {
    hasMobile: (state) => state.hasMobile,
    userInfo: (state) => state.userInfo,
    city: (state) => state.city,
    cachedViews: (state) => state.cachedViews,
    environment: (state) => state.environment,
    showBack: (state) => state.showBack,
    mercode: (state) => state.mercode,
    newDot: (state) => state.newDot,
    getWechatSignUrl: (state) => state.wxSignUrl,
    pointsValue: (state) => state.pointsValue,
    distUserInfo: (state) => state.distUserInfo,
    getUserConfigInfo: (state) => state.userConfigInfo,
    getBottomNavList: (state) => state.bottomNavList,
    getAppId: (state) => state.appId,
    getInfosStorage: (state) => state.infos_storage,
    getHexiaoInfo: (state) => state.hexiaoInfo,
  },
  mutations: {
    isWeixin(state, value) {
      state.isWeixin = value
    },

    isPath(state, value) {
      state.isPath = value
    },
    fromPath(state, value) {
      state.fromPath = value
    },
    hasMobile(state, value) {
      state.hasMobile = isNotEmpty(value)
    },
    userInfo(state, payload) {
      state.userInfo = {
        ...state.userInfo,
        ...payload,
      }
      let appId = getStorage('appId')
      let infos_storage = getAppIdStorage(appId)
      infos_storage.userInfo = state.userInfo
      setAppIdStorage(appId, infos_storage)
    },

    // 核销用户信息
    hexiao_userInfo(state, data) {
      state.hexiaoInfo = {
        ...data,
      }

      setStorage('hexiaoUserInfo', data)
    },

    city(state, value) {
      state.city = value
    },
    cachedViews(state, value) {
      state.cachedViews = value
    },

    iosPath(state, value) {
      state.iosPath = value
    },

    environment(state, value) {
      state.environment = value
      setStorage('environment', value)
    },
    showBack(state, value) {
      let appId = getStorage('appId')
      let infos_storage = getAppIdStorage(appId) || {}
      infos_storage.showBack = value
      state.showBack = value
      setAppIdStorage(appId, infos_storage)
    },
    newDot(state, value) {
      state.newDot = value
      let infos_storage = getAppIdStorage(appId)
      infos_storage.newDot = value
      setAppIdStorage(appId, infos_storage)
    },
    setWechatSignUrl(state, wxSignUrl) {
      // 关键点
      // IOS仅记录第一次进入页面时的URL
      // IOS微信切换路由实际URL不变，只能使用第一进入页面的URL进行签名
      if (isIos() && state.wxSignUrl) {
        return
      }
      state.wxSignUrl = wxSignUrl
    },
    pointsValue(state, value) {
      state.pointsValue = value
    },
    distUserInfo(state, value) {
      state.distUserInfo = value
      let appId = getStorage('appId')
      let infos_storage = getAppIdStorage(appId)
      infos_storage.distUserInfo = value
      setAppIdStorage(appId, infos_storage)
    },
    setUserConfigInfo(state, value) {
      state.userConfigInfo = value
      let appId = getStorage('appId')
      let infos_storage = getAppIdStorage(appId)
      infos_storage.userConfigInfo = value
      setAppIdStorage(appId, infos_storage)
    },
    setBottomNavList(state, value) {
      state.bottomNavList = value
      let appId = getStorage('appId')
      let infos_storage = getAppIdStorage(appId)
      infos_storage.bottomNavList = value
      setAppIdStorage(appId, infos_storage)
    },
    setInfosStorage(state, value) {
      state.infos_storage = value
      console.log('state.getAppId', state.appId)
      console.log('value', value)

      setAppIdStorage(state.appId, value)
    },
  },
  actions: {
    async getOpenStatus({ commit }) {
      try {
        const RES = await openStatus()
        const { data, code } = RES.data
        if (code === 200) {
          commit('distUserInfo', data)
        }
      } catch (err) {
        console.log('openStatus接口异常捕获', err)
      }
    },
  },
  modules: {
    Kfc,
    mc,
    mall,
    movice,
  },
})
